export default {
  root: {},
  outlined: {
    transform: 'translate(14px, 21px) scale(1)',
  },
};
